<template>
  <CRow>
    <CCol col="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="12" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Ratings',self.userId)"
                  ><i class="fas fa-file-pdf"></i></CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert :color="messageColor" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}</CAlert>
          <v-server-table :columns="columns" :url="listUrl" :options="options" ref="myTable"
                          @loaded="exports(self, 'Excel', module, 'Ratings', self.userId)">

            <template #logo="data">
              <img :src="data.row.logo" :alt="data.row.platform" width="50" height="50"/>
            </template>
            <template #url="data">
              <a :href="data.row.url" target="_blank">{{ data.row.platform }}</a>
            </template>
            <template #createdAt="data">{{ dateTimeUTCtoLocalFormat(data.row.createdAt) }}</template>
            <template #updatedAt="data">{{ dateTimeUTCtoLocalFormat(data.row.updatedAt) }}</template>
            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.edit"
                  v-on:click="viewTableRow(data.row.id)"
              >
                <i class="fas fa-eye"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {gAC} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import {required} from "vuelidate/lib/validators";
import VueToasted from "vue-toasted";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
function toast({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);
export default {
  name: "CompanyRatings",
  mixins: [Mixin],
  components: {
    VueJsonToCsv
  },
  data() {
    return {
      groupId: '',
      userId: '',
      submitted: false,
      listUrl: '/users/profile/ratings',
      json_data: [],
      messageColor: "success",
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      alertMessage: "",
      showAlert: false,
      dismissCountDownS: 0,
      msg: "",
      items: [],
      viewRounds: [],
      activePage: 1,
      selectedLetter: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      dismissCountDown: 0,
      statusOptions: [],
      self: this,
      module: gAC,
      gac: {},
      maxlength: {
        // category: Maxlength.gac.name,
      },
      columns: ["logo", "platform", "rate", 'url', 'createdAt', 'updatedAt'],
      data: [],
      options: {
        headings: {
          logo: this.$lang.profile.table.ratings.logo,
          platform: this.$lang.profile.table.ratings.platform,
          rate: this.$lang.profile.table.ratings.rate,
          url: this.$lang.profile.table.ratings.url,
          createdAt: this.$lang.profile.table.ratings.createdAt,
          updatedAt: this.$lang.profile.table.ratings.updatedAt,

        },
        editableColumns: ["platform"],
        sortable: ["platform", "rate"],
        filterable: ["platform"],
        // see the options API
      },
    };
  },
  validations: {
    gac: {
      name: {
        required,
      },
    },
  },

  created() {
    let self = this;
    self.dismissCountDown = 0;
    if (this.$route.params.id) {
      self.userId = this.$route.params.id;
      self.dismissCountDown = 0;
      self.listUrl = self.listUrl + "/" + self.userId;
    }
    store.commit('showLoader', false); // Loader Start
  },
  mounted() {
    store.commit('showLoader', false); // Loader Start
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    // self.data = this.loadData();
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    /* get from child component */
    switchFilter(show) {
      this.toggleFilterValue = show;
    },

    createTableRow() {
      let self = this;
      self.$v.$reset();
      self.submitType = "Create";
      self.gac.name = "";
      self.gac.countryId = "";
      self.largeModal = true;
      self.gac.status = 1;
    },

    viewTableRow(item) {
      let self = this;
      self.submitType = "Update";
      const id = item;
      self.editId = item;
      axios
          .get("users/profile/templates/view/" + id).then((response) => {
        if (response) {
          self.viewRounds = response.data.data;
        } else {
          self.data = [];
        }
      });
      self.largeModal = true;
    },

  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
